import { motion } from 'framer-motion';
import { PropsWithChildren } from 'react';
import { Colors } from '~/themes/colors';

export const Container = ({ children }: PropsWithChildren) => (
  <motion.div
    initial={{ opacity: 0, y: -20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    style={{
      alignContent: 'center',
      backgroundColor: Colors.white,
      borderRadius: 16,
      boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.15), 0px 6px 10px 2px rgba(0, 0, 0, 0.15)',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 720,
      minHeight: 640,
      height: 'auto',
      minWidth: 560,
      padding: '54px 38px',
      position: 'relative',
      width: '30%',
      justifySelf: 'center',
    }}
  >
    {children}
  </motion.div>
);
